import React, { useCallback, useEffect, useState } from "react";
import Group from "../../ServicosAcolhimento/Visualizar/Group";
import CriancaService from "../../../../main/services/CriancaService";
import { IrmaoTable } from "../ReferenciaFamiliar/Irmaos/Table";
import LoadingSpinner from "../../../components/LoadingSpinner";
import { Box, Link } from "@chakra-ui/react";
import SemRegistros from "../../../components/SemRegistros";
import { criancaFunc } from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import { useHistory, useParams } from "react-router-dom";
import { handleVerifyRedirectPendencia } from "../../../utils/hadleVerifyRedirectPendencia";

export const VisualizarPendencia = ({ setLoadingPainel }) => {
  const { id } = useParams();
  const history = useHistory();
  const [loadingMovimentacoes, setLoadingMovimentacoes] = useState(true);
  const { roleKeycloack, user } = useAuthProvider();
  const { idPJ } = useAppContext();

  const [dataPendencias, setDataPendencias] = useState(null);

  const columns = [
    {
      Header: "Pendências",
      accessor: "descricaoTipoPendencia",
      Cell: (props) => {
        const pendencia = props?.value;
        const idAba = props?.row?.original?.idAba;
        const idTipoPendencia = props?.row?.original?.idTipoPendencia;

        return (
          <Link
            onClick={() => {
              handleVerifyRedirectPendencia(
                idAba,
                idTipoPendencia,
                history,
                id,
                true,
                roleKeycloack,
                user,
                idPJ
              );
            }}
          >
            {pendencia ? pendencia : ""}
          </Link>
        );
      },
    },
    {
      Header: "Aba",
      accessor: "nomeAba",
      Cell: (props) => {
        const nomeAba = props?.value;

        return <span>{nomeAba ? nomeAba : ""}</span>;
      },
    },
  ];

  const getPendencias = useCallback(() => {
    setLoadingMovimentacoes(true);
    CriancaService.getPendencias(id)
      .then((res) => {
        setDataPendencias(res.data);
      })
      .catch(() => {
        console.log("Erro no get de pendencias");
      })
      .finally(() => {
        setLoadingMovimentacoes(false);
      });
  }, [id, setDataPendencias]);

  useEffect(() => {
    getPendencias();
  }, [getPendencias]);

  return roleKeycloack &&
    (roleKeycloack.includes(criancaFunc.pendenciasVisualizar) ||
      ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
        roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
        user?.orgaoExterno?.includes(idPJ))) ? (
    !loadingMovimentacoes ? (
      <Group
        title="Pendências"
        position="relative"
        dividerFalse={false}
        tooltipText={
          "As pendências sinalizadas nesse campo estão de acordo com as regras de acesso definidas para cada perfil. Nesse sentido, somente aparecerão as pendências cujo perfil do usuário tenha acesso para resolvê-las"
        }
        opcoes={true}
        showMenuItemsAtribuicao={true}
        downloadPendencias={true}
        idCrianca={id}
      >
        {dataPendencias && dataPendencias.length > 0 ? (
          <Box mt="12px">
            <IrmaoTable
              mt={"0px"}
              columns={columns}
              data={dataPendencias}
              entidade="pendencias"
              disableHeaderOptionsOpcoes={true}
            />
          </Box>
        ) : (
          <Box mt={4}>
            <SemRegistros buttonVisible={true} half />
          </Box>
        )}
      </Group>
    ) : (
      <Box mt={4}>
        <LoadingSpinner />
      </Box>
    )
  ) : (
    <Box mt={4}>
      <SemRegistros buttonVisible={true} half />
    </Box>
  );
};
